module.exports = __webpack_public_path__ + "img/109066.4458cfa9.png";